import mutations from './doctorDailyAttendance.mutations'
import actions from './doctorDailyAttendance.actions'
import getters from './doctorDailyAttendance.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
